var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadContractBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33341 12.6667H8.66675V9.88334L9.73341 10.95L10.6667 10L8.00008 7.33334L5.33341 10L6.28341 10.9333L7.33341 9.88334V12.6667ZM4.00008 14.6667C3.63341 14.6667 3.31953 14.5361 3.05841 14.275C2.7973 14.0139 2.66675 13.7 2.66675 13.3333V2.66667C2.66675 2.3 2.7973 1.98611 3.05841 1.725C3.31953 1.46389 3.63341 1.33334 4.00008 1.33334H9.33341L13.3334 5.33334V13.3333C13.3334 13.7 13.2029 14.0139 12.9417 14.275C12.6806 14.5361 12.3667 14.6667 12.0001 14.6667H4.00008ZM8.66675 6V2.66667H4.00008V13.3333H12.0001V6H8.66675Z",
    fill: "#3474E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadContractBlue);
export default __webpack_public_path__ + "static/media/upload_contract_blue.485d9a5c7a02e36ce4ade6f45d76b2ff.svg";
export { ForwardRef as ReactComponent };